export enum THEME_MODE {
  LIGHT = 'Light',
  DARK = 'Dark',
}
export interface ThemeState {
  themeMode: THEME_MODE;
}
